/**
 * Valida a estrutura da chave de acesso (44 posições, aceitando CNPJ tradicional ou
 * alfanumérico conforme NTCJ 2025.001) — equivalente ao
 * DocumentoFiscalValidationUtil.ValidarEstruturaChaveAcesso do backend:
 * ^[0-9]{6}[0-9A-Z]{14}[0-9]{24}$
 */
export function validateEstruturaChaveAcesso(chave?: string | null): boolean {
  if (!chave || chave.length !== 44) return false;
  return /^[0-9]{6}[0-9A-Z]{14}[0-9]{24}$/i.test(chave.trim());
}

/**
 * Valida o modelo da chave de acesso conforme o tipo de documento:
 *   - tipoDocumento 1 (CT-e)  → posições 20-21 == "57"
 *   - tipoDocumento 2 (NF-e)  → posições 20-21 == "55"
 * Equivalente ao ValidarModeloCompativel do MDFeDocumentoInputValidator.
 */
export function validateModeloChaveAcesso(
  chave: string,
  tipoDocumento: number
): boolean {
  if (chave.length !== 44) return false;
  const modelo = chave.substring(20, 22);
  if (tipoDocumento === 1) return modelo === "57";
  if (tipoDocumento === 2) return modelo === "55";
  return modelo === "55" || modelo === "57";
}

/**
 * Calcula o dígito verificador módulo 11 da chave de acesso
 * e valida o último dígito (posição 43).
 * Utiliza o algoritmo com conversão ASCII - 48 exatamente como o
 * DocumentoFiscalValidationUtil.CalcularModulo11ChaveAcesso do backend C#.
 */
export function validateDigitoVerificadorChaveAcesso(chave: string): boolean {
  if (chave.length !== 44) return false;

  const base = chave.substring(0, 43).toUpperCase();
  const dvInformado = parseInt(chave[43]!, 10);
  if (isNaN(dvInformado)) return false;

  let sum = 0;
  let weight = 2;
  for (let i = base.length - 1; i >= 0; i--) {
    const charCode = base.charCodeAt(i);
    const valor = charCode - 48; // ASCII - 48
    sum += valor * weight;
    weight = weight > 8 ? 2 : weight + 1;
  }

  const remainder = sum % 11;
  let dvCalculado = 11 - remainder;
  if (dvCalculado >= 10) dvCalculado = 0;

  return dvCalculado === dvInformado;
}
